export default __webpack_public_path__ + "static/media/ethcompsmall.76855450.gif";